import React, { useEffect } from 'react'
import { endTracking, startTracking } from 'services/searchTimeLoggingService'

interface Props {
  event: string;
  data?: any;
  children: React.ReactNode;
}

// This component is used to measure the time since displaying it until it is unmounted.
// It will log the time spent in the console when unmounted.
function SearchTimeLogger({
  event,
  data,
  children,
}: Props) {
  useEffect(() => {
    startTracking(event, data)
  }, [data, event])

  // log the time when the component is unmounted
  useEffect(() => {
    return () => endTracking(event)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      {children}
    </div>
  )
}

export default SearchTimeLogger
